export default "__VITE_ASSET__BQKVnuQ9__"